import React, { useState, useEffect, useMemo, useCallback } from 'react';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';
import Select from 'react-select';

import { CartItem, Business, Address, DeliveryZone } from '../../types';
import Paper from '../../components/Paper';
import Text from '../../components/Text';
import Grid from '../../components/Grid';
import CartItemCard from './CartItemCard';
import { FaNewspaper } from 'react-icons/fa';
import { getBusinessDeliveryZones } from '../../services/ApiService';
import Loader from '../../components/Loader';
import { useDispatch } from 'react-redux';
import { changeItemDeliverZone, changeItemNote, changeItemAddress } from '../../actions/cart';
import Image from 'react-bootstrap/Image';

export interface BusinessItemsPaperProps {
  business: Business;
  items: CartItem[];
  addresses: Address[]
  selectedAddress: number;
  index: number;
  editable: boolean
}

const BusinessItemsPaper: React.FC<BusinessItemsPaperProps> = ({
  business,
  items,
  addresses,
  selectedAddress,
  index,
  editable
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  // const [errorCity, setErrorCity] = useState(true);
  const [deliveryZones, setDeliveryZones] = useState<DeliveryZone[]>([]);
  const [selectedZone, setSelectedZone] = useState<{
    value: number;
    label: string;
  } | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const temp = await getBusinessDeliveryZones(business.id);
        setDeliveryZones(temp);
      } catch (e) { }
      setLoading(false);
    })();
  }, [business.id]);

  useEffect(() => {
    if (editable) {
      let address = addresses.find((x) => parseInt(x.id) === selectedAddress);
      if (!address)
        address = addresses[0]

      if (address) {
        let cityId = +address.city.id;
        let zone = deliveryZones.find((x) => cityId == x.city_id)
        // if (zone) {
        //   setErrorCity(false);
        //   parentCallback(false, index)
        //   dispatch(changeItemDeliverZone(business.id, zone));
        // } else {
        //   setErrorCity(true);
        //   parentCallback(true, index)
        // }
        setSelectedZone({ value: parseInt(address.id), label: address.name });
        dispatch(changeItemAddress(business.id, address));
      }
    }
    else {
      // setErrorCity(false);
      if (items[0].address)
        setSelectedZone({ value: +items[0].address.id, label: items[0].address.name });
    }
  }, [selectedAddress, deliveryZones, dispatch, business]);

  const handleChangeAddress = useCallback(
    (address) => {
      let tempAddress = addresses.find((x) => parseInt(x.id) === address.value);

      if (tempAddress) {
        let cityId = +tempAddress.city.id;
        let zone = deliveryZones.find((x) => cityId == x.city_id)
        // if (zone) {
        //   setErrorCity(false);
        //   parentCallback(false, index)
        //   dispatch(changeItemDeliverZone(business.id, zone));
        // } else {
        //   setErrorCity(true);
        //   parentCallback(true, index)
        // }
        dispatch(changeItemAddress(business.id, tempAddress));

      }

      setSelectedZone(address);
      dispatch(
        changeItemDeliverZone(
          business.id,
          deliveryZones.find((x) => x.city_id === address.value) as any,
        ),

      );
    },
    [business, dispatch, deliveryZones],
  );

  const handleChangeNote = useCallback(
    (e) => {
      dispatch(changeItemNote(business.id, e.target.value));
    },
    [dispatch, business],
  );
  return (
    <Paper withShadow={false} className={classes.paper}>
      <div className={clsx('p-3', classes.header)}>
        <Text className="m-0" as="h5" color="white" bold>
          {business.name} ({items.length})
        </Text>
        {/* {business.logoUrl}
        <img src={business.logoUrl} /> */}
        <Image
          className={classes.avatar}
          src={business.logoUrl}
          alt={business.name}
        />
      </div>
      <div className={clsx(classes.body, 'p-3')}>
        <Loader center loading={loading}>
          {() => (
            <>
              <Grid
                data={items}
                itemsPerRow={{ xs: 1, lg: 2 }}
                renderItem={(item: CartItem) => <CartItemCard editable={editable} item={item} />}
                keyExtractor={(item: CartItem) => item.id}
                fluid
              />

              <div
                className={clsx('mt-5', 'mb-3', 'px-5', classes.addressSelect)}
              >
                <Text as="h3" className="m-0" bold>
                  Where to Deliver ?
                </Text>
                <Select
                  isDisabled={true}
                  className={classes.select}
                  value={selectedZone}
                  options={addresses.map((zone) => ({
                    label: zone.name,
                    value: parseInt(zone.id),
                  }))}
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      border: 'none',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                    }),
                    indicatorSeparator: () => ({ display: 'none' }),
                  }}
                  onChange={handleChangeAddress}
                />
              </div>
              {/* {errorCity ?
                <Text color="red" className='px-5'>Vendor can't deliver at this address. Please choose another.
              </Text> : null
              } */}
              <hr />
              <div className={clsx('my-5', 'px-5', classes.noteBox)}>
                <FaNewspaper className={classes.noteIcon} />
                <input
                  disabled={!editable}
                  className={classes.noteInput}
                  placeholder="Add your note for vendor (Optional)"
                  onChange={handleChangeNote}
                  value={items[0].note}
                />
              </div>
            </>
          )}
        </Loader>
      </div>
    </Paper>
  );
};

const useStyles = createUseStyles({
  paper: {
    overflow: 'visible',
  },
  header: {
    backgroundColor: '#522583',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    position: 'relative'
  },
  body: {},
  addressSelect: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '24px',
  },
  
  '@media (max-width: 768px)': {
    addressSelect: {
      display: 'block',
    },
    noteInput: {
      fontSize: '19px !important',
    }
  },
  select: {
    minWidth: '200px',
  },
  noteBox: {
    position: 'relative',
  },
  noteIcon: {
    fontSize: '32px',
    position: 'absolute',
    left: '3rem',
    top: '2px',
    color: '#333',
  },
  noteInput: {
    width: '100%',
    marginLeft: '48px',
    fontWeight: 'bold',
    fontSize: '24px',
    color: '#333',
    border: 'none',
    outline: 'none',
    '::placeholder': {
      color: '#ddd',
    },
  },
  avatar: {
    position: 'absolute',
    right: '16px',
    borderRadius: '10%',
    top: '8px',
    width: '40px',
    height: '40px',
    objectFit: 'cover'
  }
});

export default BusinessItemsPaper;
